module.exports = "pegasus/assets/blocks/column-lp16-basic.png";